import { render, staticRenderFns } from "./subjectModal.vue?vue&type=template&id=19540ef6&scoped=true&"
import script from "./subjectModal.vue?vue&type=script&lang=js&"
export * from "./subjectModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19540ef6",
  null
  
)

export default component.exports